import { Component, ElementRef, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { HistoryItem } from '@reflact/ipkv-types';
import { MarkdownComponent, MarkdownModule } from 'ngx-markdown';
import { Button } from "primeng/button";
import { Api } from '../../../api';
import { ChatService } from '../chat.service';

@Component({
  selector: 'app-chat-bubble',
  imports: [MarkdownModule, Button],
  templateUrl: './chat-bubble.html',
  styleUrl: './chat-bubble.scss'
})
export class ChatBubble {
  @Input() public message!: HistoryItem;

  @ViewChild(MarkdownComponent, { read: ElementRef }) public markdown!: ElementRef;
  @ViewChild("btn") public btn!: TemplateRef<any>;

  public api = inject(Api);
  public chatService = inject(ChatService);

  public renderButtons() {
    const paragraphs = this.markdown.nativeElement.querySelectorAll("p.teilaufgabentext");

    const fallaufgabe = this.api.fallaufgabe;
    const aufgabe = fallaufgabe?.aufgaben.find(a => a._id == this.api.fallaufgabeStatus?.userSelectedAufgabenId);
    if (!aufgabe) return;

    const tableIndizes = aufgabe.teilaufgaben.filter(ta => ta.type == "table").map(ta => ta.teilaufgabenIndex);
    paragraphs.forEach((p: HTMLElement) => {
      const index = parseInt(p.dataset["teilaufgabenindex"]!);
      const teilaufgabe = aufgabe.teilaufgaben.find((ta) => ta.teilaufgabenIndex === index);
      if (teilaufgabe == null) return;

      if (p.dataset['copyTracked'] !== 'true') {
        p.dataset['copyTracked'] = 'true';
        p.addEventListener('copy', () => {
          void this.api.trackCopyEvent(teilaufgabe._id, aufgabe._id, 'frage');
        });
      }

      if (!tableIndizes.includes(index)) return;
      const view = this.btn.createEmbeddedView({ teilaufgabenindex: index });
      view.detectChanges();
      view.rootNodes.forEach(node => p.appendChild(node));
    });
  }
}
